module.exports = __webpack_public_path__ + "media/src/images/smtx__signet--white-d8c03d90fdac784dfd97f5c2f6e2be19.svg";